import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const NftPrice = () => {

  const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.chinaTomi;
  const contract = chinaContract(tokenAddress, web3);


  const nftPrice = useCallback(
    async (aa) => {
 
      try {
        const buy = await contract.methods.nftPricing(aa).call()
        return buy/10**6;
      } catch (error) {
        throw error;
      }
    },
    [contract, account,web3]
  );
  return { nftPrice: nftPrice };
};
export default NftPrice;